import UIComponent from "../ui/component.js";

export class MeetingSourcePicker extends UIComponent {
    init() {
        this.buttons = [...this.element.querySelectorAll('[data-meeting-source]')];
        this.panels = [...this.element.querySelectorAll('[data-meeting-source-panel]')];
        this.options = this.element.querySelector('[data-meeting-source-options]');

        this.buttons.forEach((button) => {
            button.addEventListener('click', () => {
                if (button.disabled || button.getAttribute('aria-disabled') === 'true') {
                    return;
                }

                if (this.element.querySelector('[data-meeting-recording="1"]')) {
                    return;
                }

                this.select(button.dataset.meetingSource);
            });
        });
    }

    select(sourceId) {
        this.buttons.forEach((button) => {
            const isActive = button.dataset.meetingSource === sourceId && !button.disabled;

            button.classList.toggle('is-active', isActive);
            button.setAttribute('aria-checked', isActive ? 'true' : 'false');
        });

        this.panels.forEach((panel) => {
            const isActive = panel.dataset.meetingSourcePanel === sourceId;
            panel.classList.toggle('d-none', !isActive);
            panel.toggleAttribute('hidden', !isActive);
        });

        if (this.options) {
            this.options.classList.remove('d-none');
            this.options.removeAttribute('hidden');
        }
    }
}
